exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips_promotion{position:absolute;right:-3px;top:-11px;display:inline-block;line-height:18px}.tips_promotion .inner{display:inline-block;background:linear-gradient(108deg,transparent 16px,#e01e02 0,#e01e02);padding:0 6px 0 22px;border-radius:0 5px;text-align:left;color:#fff;font-size:12px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:83px}.tips_promotion:before{content:\"\";position:absolute;width:0;height:0;right:0;bottom:-2px;border-top:7px solid #ad3422;border-right:3px solid transparent;border-left:4px solid transparent}", ""]);

// exports
